import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Header from '../Header';
// import { StyledBoxInside, StyledMenuTabs } from './style';

// import { employeeMenu, departmentMenu } from '../../../constants/menuTabs';

const Employee = props => {
  const {
    children,
    history,
    location,
    // textButtonAction,
    // type,
    // idUser,
    // idDepartment,
    // typology,
    // match,
    // roles,
    withHeader,
    username
    // hideMenuTabs
  } = props;
  // const getMenuTabs = (id, isConnected) => {
  //   let menu;
  //   if (type === 'department') {
  //     menu = departmentMenu;
  //   } else {
  //     menu =
  //       typology === 'EXTERNAL'
  //         ? employeeMenu.filter(
  //             item =>
  //               item.id === 'Perfil' ||
  //               item.id === 'Editar' ||
  //               item.id === 'Datos'
  //           )
  //         : employeeMenu.filter(
  //             item => !item.rol || roles.indexOf(item.rol) !== -1
  //           );
  //   }
  //   const MenuUpdated = menu.map(item => {
  //     const { route } = item;
  //     const indexMenu = route.lastIndexOf('/');
  //     const routeToArray = route.split('');

  //     if (!route.includes('http')) {
  //       routeToArray[indexMenu] = `/${id}/`;
  //     }

  //     return {
  //       ...item,
  //       route: routeToArray.join('')
  //     };
  //   });

  //   return isConnected ? MenuUpdated : [MenuUpdated[0]];
  // };

  // const getDataMenu = () => {
  //   const {
  //     params: { id }
  //   } = match;

  //   const idConnected = type === 'department' ? idDepartment : idUser;
  //   const isConnected = idConnected === Number(id);
  //   return getMenuTabs(idConnected, isConnected);
  // };

  const childrenWithProps = React.Children.map(children, child => {
    // Checking isValidElement is the safe way and avoids a typescript// error too.
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { username });
    }
    return child;
  });
  return (
    <div className="employee_container">
      {withHeader && (
        <Header showHeader location={location} history={history} />
      )}
      {/* {!hideMenuTabs && (
        <StyledBoxInside>
          <StyledMenuTabs
            currentPath={location.pathname}
            dataMenu={getDataMenu()}
            clickHandler={route => {
              if (route.includes('http')) {
                window.open(route, '_blank');
              } else {
                history.push({ pathname: route });
              }
            }}
            textButtonAction={textButtonAction}
            fromExternalMenu={location.state && location.state.fromExternalMenu}
          />
        </StyledBoxInside> */}
      {/* )} */}
      {childrenWithProps}
    </div>
  );
};

Employee.prototype = {
  children: PropTypes.node,
  textButtonAction: PropTypes.string,
  idDepartment: PropTypes.number,
  type: PropTypes.string,
  typology: PropTypes.string,
  withHeader: PropTypes.bool
};

Employee.defaultProps = {
  type: 'employee',
  withHeader: true
};

const mapStateToProps = ({ user }) => ({
  idDepartment: user.user.idDepartment,
  username: user.user.username,
  idUser: user.user.userId,
  typology: user.user.typology,
  roles: user.user.roles
});

export default connect(mapStateToProps)(Employee);
